import './components/calculators/format';
import './components/calculators/finance';
import './components/calculators/calculator-products';
import './components/calculators/mortgage';
import './components/calculators/input';
import './components/calculators/road-tax';

// =====================================================================
//  CAR LOAN / HIRE PURCHASE — interactivity layer
// =====================================================================
(function () {
  const fmt = Calc.format;
  const fin = Calc.finance;

  // Road tax comes from the SAME DB-editable JPJ table the road-tax calculator
  // uses (Calc.data.roadTax), so a dashboard rate change reaches both. This page
  // has no region/class/ownership inputs, so it assumes Peninsular saloon private.
  const RT_RATES = (window.Calc && Calc.data && Calc.data.roadTax) ? Calc.data.roadTax : null;
  const RT_SELECTION = { region: 'peninsular', vclass: 'saloon', ownership: 'private' };
  function roadTaxAnnual(cc) {
    if (!RT_RATES || !cc || cc <= 0) return 0;
    return Calc.roadTax.annual(RT_RATES, Object.assign({ cc }, RT_SELECTION)).total;
  }

  // Insurance stays a local estimate: ~2.2% of market value, less the NCD tier.

  function carInsuranceEstimate(marketValue, ncdYears = 0) {
    if (!marketValue || marketValue <= 0) return 0;
    const ncdScale = [0, 0.25, 0.30, 0.3833, 0.45, 0.55];
    const ncd = ncdScale[Math.min(ncdYears, 5)];
    const gross = marketValue * 0.022;
    return gross * (1 - ncd);
  }

  const state = {
    carPrice: 100000,
    downPaymentPct: 0.10,
    interestRate: 0.0285,
    tenure: 7,
    engineCC: 1500,
    ncdYears: 0,
    activeTab: 'breakdown',
  };

  const loanAmount = () => state.carPrice * (1 - state.downPaymentPct);
  const downPayment = () => state.carPrice * state.downPaymentPct;

  const setText = (id, val) => {
    const el = document.getElementById(id);
    if (el) el.textContent = val;
  };
  // Write a value into a placeholder span (text is in HTML, JS only writes the value).
  const setVal = (sel, val) => {
    const el = document.querySelector(sel);
    if (el) el.textContent = val;
  };
  // Show exactly one of the sibling spans inside `parentId`, by class name.
  const showOne = (parentId, shownClass) => {
    const parent = document.getElementById(parentId);
    if (!parent) return;
    parent.querySelectorAll(':scope > span').forEach(s => {
      s.classList.toggle('d-none', !s.classList.contains(shownClass));
    });
  };

  // Sync state -> form controls. Delegates to Calc.input.syncValue so
  // Inputmask-attached inputs receive reformatted display values.
  function syncInput(id, val) {
    Calc.input.syncValue(id, val);
  }
  function updateDisplays() {
    syncInput('cl-price-input',  state.carPrice);
    syncInput('cl-down-input',   (state.downPaymentPct * 100).toFixed(0));
    syncInput('cl-rate-input',   (state.interestRate * 100).toFixed(2));
    syncInput('cl-tenure-input', state.tenure);
    syncInput('cl-cc-input',     state.engineCC);
    syncInput('cl-ncd-input',    state.ncdYears);
    setVal('.cl-down-amount', downPayment().toLocaleString());
  }

  function updateStatBand() {
    const calc = fin.flatRate(loanAmount(), state.interestRate, state.tenure);
    const insurance = carInsuranceEstimate(state.carPrice, state.ncdYears);
    const roadTax = roadTaxAnnual(state.engineCC);
    const annualOwnership = calc.monthlyInstalment * 12 + insurance + roadTax;

    setText('cl-stat-monthly', fmt.money(calc.monthlyInstalment, 0));
    setText('cl-stat-ins',     fmt.money(insurance, 0));
    setText('cl-stat-tax',     fmt.money(roadTax, 0));
    setText('cl-stat-annual',  fmt.money(annualOwnership, 0));
  }

  function updateBreakdown() {
    const calc = fin.flatRate(loanAmount(), state.interestRate, state.tenure);
    const effRate = fin.solveEffectiveRate(loanAmount(), calc.monthlyInstalment, state.tenure);

    setText('cl-r-price',    fmt.money(state.carPrice));
    setVal('.cl-r-down-amount', fmt.money(downPayment()));
    setVal('.cl-r-down-pct',    (state.downPaymentPct * 100).toFixed(0));
    setText('cl-r-loan',     fmt.money(loanAmount()));
    setVal('.cl-r-tenure-y', state.tenure);
    setVal('.cl-r-tenure-m', state.tenure * 12);
    setVal('.cl-r-rate-num', fmt.percent(state.interestRate));
    setVal('.cl-r-eff-num',  fmt.percent(effRate));
    setText('cl-r-interest', fmt.money(calc.totalInterest));
    setText('cl-r-total',    fmt.money(calc.totalRepayment));
    setText('cl-r-monthly',  fmt.money(calc.monthlyInstalment));
  }

  function updateAmortization() {
    const host = document.getElementById('cl-amort');
    if (!host) return;
    Calc.amortView.renderInline(host, {
      startExpanded: true,
      amount: loanAmount(),
      rate: state.interestRate,
      years: state.tenure,
      method: 'flat',
    });
  }

  function updateOwnership() {
    const calc = fin.flatRate(loanAmount(), state.interestRate, state.tenure);
    const insurance = carInsuranceEstimate(state.carPrice, state.ncdYears);
    const roadTax = roadTaxAnnual(state.engineCC);
    const annual = calc.monthlyInstalment * 12 + insurance + roadTax;
    const lifetime = annual * state.tenure;
    const totalCost = lifetime + downPayment();

    setText('cl-o-down',      fmt.money(downPayment()));
    setText('cl-o-monthly12', fmt.money(calc.monthlyInstalment * 12));
    setText('cl-o-ins',       fmt.money(insurance));
    setVal('.cl-o-tax-cc',    state.engineCC);
    setText('cl-o-tax',       fmt.money(roadTax));
    setText('cl-o-annual',    fmt.money(annual));
    setVal('.cl-o-lifetime-y', state.tenure);
    setText('cl-o-lifetime',  fmt.money(lifetime));
    setText('cl-o-total',     fmt.money(totalCost));
  }

  function refresh() {
    updateDisplays();
    updateStatBand();
    if (state.activeTab === 'breakdown') {
      updateBreakdown();
      updateAmortization();
    } else {
      updateOwnership();
    }
  }

  function activateTab(tabId) {
    state.activeTab = tabId;
    document.querySelectorAll('#cl-tabs .btn-tab').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.tab === tabId);
    });
    document.querySelectorAll('.tab-panel').forEach(panel => {
      panel.classList.toggle('d-none', panel.id !== `cl-tab-${tabId}`);
    });
    if (tabId === 'breakdown') { updateBreakdown(); updateAmortization(); }
    else { updateOwnership(); }
  }

  function bindEvents() {
    // Bind directly to each form control. `input` for typing (number),
    // `change` for committed select choice — both events bubble fine but
    // direct binding sidesteps any delegation/focus weirdness.
    const bind = (id, fn) => {
      const el = document.getElementById(id);
      if (!el) return;
      // Calc.input.getValue returns a clean number for masked or plain inputs.
      const handler = () => { fn(Calc.input.getValue(el)); refresh(); };
      el.addEventListener('input', handler);
      el.addEventListener('change', handler);
    };
    bind('cl-price-input',  v => state.carPrice       = v || 0);
    bind('cl-down-input',   v => state.downPaymentPct = (v || 0) / 100);
    bind('cl-rate-input',   v => state.interestRate   = (v || 0) / 100);
    bind('cl-tenure-input', v => state.tenure         = v || 1);
    bind('cl-cc-input',     v => state.engineCC       = v || 0);
    bind('cl-ncd-input',    v => state.ncdYears       = v || 0);

    document.querySelectorAll('#cl-tabs .btn-tab').forEach(btn => {
      btn.addEventListener('click', () => activateTab(btn.dataset.tab));
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindEvents();
    refresh();
  });
})();